import { useEffect } from "react";
import { useLang } from "../i18n/LanguageContext";

const OG_LOCALES = { sq: "sq_AL", en: "en_US", it: "it_IT" };
const SITE = "https://brotherstaxi.al";

const SEO = ({ title, description, path = "/", keywords, ogImage = "/logo.png", type = "website" }) => {
  const { lang } = useLang();

  useEffect(() => {
    if (title) document.title = title;

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    const setLink = (rel, href, hrefLang) => {
      const selector = hrefLang
        ? `link[rel="${rel}"][hreflang="${hrefLang}"]`
        : `link[rel="${rel}"]:not([hreflang])`;
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        if (hrefLang) el.setAttribute("hreflang", hrefLang);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    // Open Graph
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:url", `${SITE}${path}`, "property");
    setMeta("og:type", type, "property");
    setMeta("og:locale", OG_LOCALES[lang] || "sq_AL", "property");
    setMeta("og:site_name", "Brothers Taxi", "property");
    setMeta("og:image", `${SITE}${ogImage}`, "property");

    // Twitter Card
    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", `${SITE}${ogImage}`);

    // Robots
    setMeta("robots", "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1");

    // Geo (local SEO for Lushnje, Albania)
    setMeta("geo.region", "AL-09");
    setMeta("geo.placename", "Lushnje");
    setMeta("geo.position", "40.9419;19.7050");
    setMeta("ICBM", "40.9419, 19.7050");

    // Canonical
    setLink("canonical", `${SITE}${path}`);

    // hreflang alternates
    setLink("alternate", `${SITE}${path}`, "sq");
    setLink("alternate", `${SITE}${path}`, "en");
    setLink("alternate", `${SITE}${path}`, "it");
    setLink("alternate", `${SITE}${path}`, "x-default");

    // <html lang="">
    document.documentElement.lang = lang;
  }, [title, description, path, keywords, ogImage, type, lang]);

  return null;
};

export default SEO;
